import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/buildhome/repo/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/buildhome/repo/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/opt/buildhome/repo/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.5.7_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/script.js");
